export default __webpack_public_path__ + "static/media/cowo visa.2b814957.jpg";